__turbopack_context__.v({
  "action": "SimulatorPilotAccessCard-module__iqf1Qq__action",
  "avatar": "SimulatorPilotAccessCard-module__iqf1Qq__avatar",
  "card": "SimulatorPilotAccessCard-module__iqf1Qq__card",
  "eyebrow": "SimulatorPilotAccessCard-module__iqf1Qq__eyebrow",
  "identity": "SimulatorPilotAccessCard-module__iqf1Qq__identity",
  "status": "SimulatorPilotAccessCard-module__iqf1Qq__status",
});
